import type { LocalShortlist } from './store';
import { DIST_PREFIX } from './store';
import type { ComuneLight } from '@/data';

function csvEscape(v: string | number | null | undefined): string {
  if (v === null || v === undefined) return '';
  const s = String(v);
  if (/[",\n\r;]/.test(s)) return '"' + s.replace(/"/g, '""') + '"';
  return s;
}

export function buildShortlistCsv(list: LocalShortlist, byIstat: Map<string, ComuneLight>): string {
  const header = ['istat', 'name', 'province', 'altitude_m', 'lat', 'lon', 'note'];
  const lines = [header.join(',')];
  for (const istat of list.comuneIstats) {
    if (istat.startsWith(DIST_PREFIX)) continue; // районы — не comuni, в CSV не выгружаем
    const c = byIstat.get(istat);
    const row = [
      istat,
      c?.name ?? '',
      c?.prov ?? '',
      c?.alt ?? '',
      c?.lat ?? '',
      c?.lon ?? '',
      list.notes[istat] ?? '',
    ];
    lines.push(row.map(csvEscape).join(','));
  }
  return lines.join('\n');
}

export function exportShortlistCsv(list: LocalShortlist, byIstat: Map<string, ComuneLight>) {
  const csv = buildShortlistCsv(list, byIstat);
  const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8' }); // BOM for Excel
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  const stamp = new Date().toISOString().slice(0, 10);
  const safeName = list.name.replace(/[^\w-]+/g, '_').slice(0, 60);
  a.href = url;
  a.download = `${safeName || 'shortlist'}_${stamp}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
